import axios from "axios"
import qs from "qs"
import { getAccountIdFromJWT, getUserIdFromJWT } from "ui/utils/token"

import { LocalStorageService } from "./LocalStorageService"

export let API_URL = "https://api.jobintrans.eu/api"
const API_ACCESS_KEY = process.env.REACT_APP_API_ACCESS_KEY ?? ""

if (process.env) {
  if (process.env.REACT_APP_API_URL) {
    API_URL = process.env.REACT_APP_API_URL
  }
}

export const APIService = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    "X-Access-Key": API_ACCESS_KEY,
  },
  paramsSerializer: params => {
    return qs.stringify(params, {
      arrayFormat: "brackets",
    })
  },
})

APIService.interceptors.request.use(
  async config => {
    const token = await LocalStorageService.getObject("token")
    config.baseURL = API_URL
    config.headers!["X-Access-Key"] = API_ACCESS_KEY
    if (token) {
      config.headers!.Authorization = `Bearer ${token}`
    }
    if (config.url!.includes(":userId") && token) {
      const id = getUserIdFromJWT(token)
      config.url = config.url!.replace(":userId", id)
    }
    if (config.url!.includes(":accountId") && token) {
      const accountId = getAccountIdFromJWT(token)
      config.url = config.url!.replace(":accountId", accountId)
    }
    if (config.url!.includes(":profileId")) {
      const profileId = await LocalStorageService.getObject("profileId")
      if (profileId) {
        config.url = config.url!.replace(":profileId", profileId)
      }
    }

    return config
  },
  error => {
    console.log(error.data)
    return Promise.reject(error)
  },
)

APIService.interceptors.response.use(
  async response => {
    return response.data
  },
  async error => {
    const originalRequest = error.config

    if (error.response?.status === 401 && !originalRequest._retry) {
      LocalStorageService.removeObject("token")
    }

    return Promise.reject(error)
  },
)

export const APINoAuthService = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: params => {
    return qs.stringify(params, {
      arrayFormat: "brackets",
    })
  },
})

APINoAuthService.interceptors.response.use(
  async response => {
    return response.data
  },
  async error => {
    console.log(error.data)
    return Promise.reject(error)
  },
)

export const EmptyAPIService = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
})

EmptyAPIService.interceptors.response.use(
  async response => {
    return response.data
  },
  async error => {
    return Promise.reject(error)
  },
)
